import { render } from "../utils/render";
import { templateError } from "../constants/elements";
export const startError = (): void => {
  const errorElement = templateError.content.cloneNode(true) as Element;
  errorElement.querySelector("button")?.addEventListener("click", () => window.location.reload());
  render(errorElement, "error");
};
